export const NAME = 'notifications';
